<!-- Página de Login — TecGurus Empleos -->

<!-- Loading overlay -->
<div *ngIf="cargandoSocial"
     class="tw-fixed tw-inset-0 tw-z-50 tw-flex tw-items-center tw-justify-center tw-bg-white/80 tw-backdrop-blur-sm">
  <div class="tw-text-center">
    <div class="tw-mx-auto tw-w-12 tw-h-12 tw-rounded-full tw-border-4 tw-border-blue-100 tw-border-t-blue-600 tw-animate-spin"></div>
    <p class="tw-mt-3 tw-text-slate-600 tw-font-medium">Iniciando sesión…</p>
  </div>
</div>

<!-- ── 3-column layout ─────────────────────────────────────────────────────── -->
<div class="tw-bg-slate-50 lg:tw-flex tw-items-start">

  <!-- ── LEFT PANEL: Brand ──────────────────────────────────────────────────── -->
  <div class="tw-hidden lg:tw-flex tw-flex-col tw-justify-center tw-w-72 tw-shrink-0 tw-px-10 tw-sticky tw-top-0"
       style="background:linear-gradient(160deg,#0f172a 0%,#1e3a5f 50%,#1d4ed8 100%);height:calc(100vh - 64px);overflow:hidden">

    <h1 class="tw-text-3xl tw-font-extrabold tw-text-white tw-leading-tight">
      Bienvenido a<br>TecGurus Empleos
    </h1>
    <p class="tw-mt-3 tw-text-blue-200 tw-text-sm tw-leading-relaxed">
      Encuentra talento tech o encuentra tu próximo gran reto profesional.
    </p>

    <ul class="tw-mt-8 tw-space-y-5">
      <li class="tw-flex tw-items-start tw-gap-3 tw-text-white tw-text-sm">
        <div class="tw-w-8 tw-h-8 tw-rounded-lg tw-bg-white/10 tw-flex tw-items-center tw-justify-center tw-shrink-0 tw-mt-0.5">
          <svg class="tw-w-4 tw-h-4" fill="none" viewBox="0 0 24 24" stroke="currentColor" stroke-width="2">
            <path stroke-linecap="round" stroke-linejoin="round" d="M21 21l-5.197-5.197m0 0A7.5 7.5 0 105.196 5.196a7.5 7.5 0 0010.607 10.607z"/>
          </svg>
        </div>
        <span class="tw-leading-snug">Miles de vacantes tech actualizadas</span>
      </li>
      <li class="tw-flex tw-items-start tw-gap-3 tw-text-white tw-text-sm">
        <div class="tw-w-8 tw-h-8 tw-rounded-lg tw-bg-white/10 tw-flex tw-items-center tw-justify-center tw-shrink-0 tw-mt-0.5">
          <svg class="tw-w-4 tw-h-4" fill="none" viewBox="0 0 24 24" stroke="currentColor" stroke-width="2">
            <path stroke-linecap="round" stroke-linejoin="round" d="M9 12.75L11.25 15 15 9.75m-3-7.036A11.959 11.959 0 013.598 6 11.99 11.99 0 003 9.749c0 5.592 3.824 10.29 9 11.623 5.176-1.332 9-6.03 9-11.622 0-1.31-.21-2.571-.598-3.751h-.152c-3.196 0-6.1-1.248-8.25-3.285z"/>
          </svg>
        </div>
        <span class="tw-leading-snug">Procesos seguros y confiables</span>
      </li>
      <li class="tw-flex tw-items-start tw-gap-3 tw-text-white tw-text-sm">
        <div class="tw-w-8 tw-h-8 tw-rounded-lg tw-bg-white/10 tw-flex tw-items-center tw-justify-center tw-shrink-0 tw-mt-0.5">
          <svg class="tw-w-4 tw-h-4" fill="none" viewBox="0 0 24 24" stroke="currentColor" stroke-width="2">
            <path stroke-linecap="round" stroke-linejoin="round" d="M15 19.128a9.38 9.38 0 002.625.372 9.337 9.337 0 004.121-.952 4.125 4.125 0 00-7.533-2.493M15 19.128v-.003c0-1.113-.285-2.16-.786-3.07M15 19.128v.106A12.318 12.318 0 018.624 21c-2.331 0-4.512-.645-6.374-1.766l-.001-.109a6.375 6.375 0 0111.964-3.07M12 6.375a3.375 3.375 0 11-6.75 0 3.375 3.375 0 016.75 0zm8.25 2.25a2.625 2.625 0 11-5.25 0 2.625 2.625 0 015.25 0z"/>
          </svg>
        </div>
        <span class="tw-leading-snug">Conecta con las mejores empresas del sector</span>
      </li>
    </ul>
  </div>

  <!-- ── CENTER: Login Card ─────────────────────────────────────────────────── -->
  <div class="tw-flex-1 tw-flex tw-items-center tw-justify-center tw-px-4 tw-py-6">
    <div class="tw-w-full tw-max-w-md">

      <div class="tw-bg-white tw-rounded-2xl tw-shadow-xl tw-p-8">

        <!-- Header -->
        <div class="tw-text-center tw-mb-6">
          <div class="tw-w-12 tw-h-12 tw-mx-auto tw-mb-3 tw-rounded-xl tw-bg-blue-50 tw-flex tw-items-center tw-justify-center">
            <svg class="tw-w-6 tw-h-6 tw-text-blue-700" fill="none" viewBox="0 0 24 24" stroke="currentColor" stroke-width="1.5">
              <path stroke-linecap="round" stroke-linejoin="round"
                    d="M16.5 10.5V6.75a4.5 4.5 0 10-9 0v3.75m-.75 11.25h10.5a2.25 2.25 0 002.25-2.25v-6.75a2.25 2.25 0 00-2.25-2.25H6.75a2.25 2.25 0 00-2.25 2.25v6.75a2.25 2.25 0 002.25 2.25z"/>
            </svg>
          </div>
          <h2 class="tw-text-2xl tw-font-bold tw-text-slate-900">Accede a tu cuenta</h2>
          <p class="tw-mt-1.5 tw-text-sm tw-text-slate-500">Usa el mismo método con el que te registraste</p>
        </div>

        <!-- WhatsApp-first entry point -->
        <button *ngIf="waStep === 'idle'" (click)="openWhatsapp()" type="button"
                class="tw-w-full tw-h-12 tw-flex tw-items-center tw-justify-center tw-gap-2
                       tw-rounded-xl tw-text-white tw-font-semibold tw-text-sm tw-border-0 tw-cursor-pointer tw-mb-3"
                style="background:#25D366">
          <svg class="tw-w-5 tw-h-5" fill="currentColor" viewBox="0 0 448 512">
            <path d="M380.9 97.1C339 55.1 283.2 32 223.9 32c-122.4 0-222 99.6-222 222 0 39.1 10.2 77.3 29.6 111L1.9 480l117.7-30.9c32.4 17.7 68.9 27 106.2 27h.1c122.3 0 224.1-99.6 224.1-222 0-59.3-25.2-115-69.1-157zm-157 341.6c-33.2 0-65.7-8.9-94-25.7l-6.7-4-69.8 18.3L72 359.2l-4.4-7c-18.5-29.4-28.2-63.3-28.2-98.2 0-101.7 82.8-184.5 184.6-184.5 49.3 0 95.6 19.2 130.4 54.1 34.8 34.9 56.2 81.2 56.1 130.5 0 101.8-84.9 184.6-186.6 184.6zm101.2-138.2c-5.5-2.8-32.8-16.2-37.9-18-5.1-1.9-8.8-2.8-12.5 2.8-3.7 5.6-14.3 18-17.6 21.7-3.2 3.7-6.5 4.2-12 1.4-32.6-16.3-54-29.1-75.5-66-5.7-9.8 5.7-9.1 16.3-30.3 1.8-3.7.9-6.9-.6-9.7-1.5-2.8-13.4-32.3-18.3-44.2-4.8-11.8-9.7-10.2-13.4-10.4-3.5-.2-7.5-.2-11.5-.2-4 0-10.5 1.5-16 7.4-5.5 5.9-21.1 20.6-21.1 49.7 0 29.1 21.1 57.4 24 61.6 2.9 4.2 39.4 60.2 95.8 82 56.4 21.8 56.4 14.5 66.5 13.6 10.2-.9 32.8-13.4 37.4-26.4 4.6-13 4.6-24.1 3.2-26.4-1.3-2.5-5-4-10.5-6.7z"/>
          </svg>
          Continuar con WhatsApp
        </button>

        <!-- WhatsApp: paso teléfono -->
        <div *ngIf="waStep === 'phone'" class="tw-mb-5">
          <button (click)="closeWhatsapp()" type="button"
                  class="tw-flex tw-items-center tw-gap-1 tw-text-xs tw-text-slate-400 tw-bg-transparent tw-border-0 tw-cursor-pointer tw-mb-3 tw-p-0">
            ← Volver
          </button>
          <p class="tw-text-sm tw-text-slate-600 tw-mb-3">Ingresa tu número y te enviamos un código por WhatsApp.</p>
          <div class="tw-flex tw-items-center tw-gap-2 tw-mb-2">
            <select [(ngModel)]="selectedDialCode" [ngModelOptions]="{standalone: true}"
                    class="tw-py-2.5 tw-px-3 tw-rounded-xl tw-border tw-text-sm tw-bg-slate-50 tw-font-medium tw-text-slate-600 tw-outline-none"
                    [style.borderColor]="waPhoneError ? '#dc2626' : '#e2e8f0'">
              <option *ngFor="let c of countries" [value]="c.dial">{{ c.flag }} +{{ c.display }}</option>
            </select>
            <input type="tel" inputmode="numeric" [ngModel]="waPhoneNumber" (ngModelChange)="onWaPhoneChange($event)"
                   [ngModelOptions]="{standalone: true}"
                   placeholder="1122334455" maxlength="15"
                   class="tw-flex-1 tw-px-4 tw-py-2.5 tw-rounded-xl tw-border tw-text-sm tw-outline-none"
                   [style.borderColor]="waPhoneError ? '#dc2626' : '#e2e8f0'"
                   (keyup.enter)="sendWaOtp()">
          </div>
          <p *ngIf="waPhoneError" class="tw-text-xs tw-text-red-600 tw-mt-1">{{ waPhoneError }}</p>
          <button (click)="sendWaOtp()" [disabled]="waSendingOtp" type="button"
                  class="tw-w-full tw-mt-3 tw-py-3 tw-rounded-xl tw-text-white tw-font-semibold tw-text-sm tw-border-0 tw-cursor-pointer"
                  [style.background]="waSendingOtp ? '#94a3b8' : '#25D366'">
            <span *ngIf="!waSendingOtp">Enviar código por WhatsApp</span>
            <span *ngIf="waSendingOtp">Enviando...</span>
          </button>
        </div>

        <!-- WhatsApp: paso código OTP -->
        <div *ngIf="waStep === 'otp'" class="tw-mb-5 tw-text-center">
          <button (click)="closeWhatsapp()" type="button"
                  class="tw-flex tw-items-center tw-gap-1 tw-text-xs tw-text-slate-400 tw-bg-transparent tw-border-0 tw-cursor-pointer tw-mb-3 tw-p-0">
            ← Volver
          </button>
          <p class="tw-text-sm tw-text-slate-500 tw-mb-4">
            Enviamos un código a <span class="tw-font-medium">+{{ waFullPhone }}</span>
          </p>
          <input type="text" [ngModel]="waOtpCode" (ngModelChange)="onWaOtpChange($event)" [ngModelOptions]="{standalone: true}" [disabled]="waVerifyingOtp"
                 maxlength="6" inputmode="numeric" autocomplete="one-time-code"
                 placeholder="000000"
                 class="tw-w-48 tw-px-4 tw-py-3 tw-rounded-xl tw-border tw-text-xl tw-text-center tw-tracking-[8px] tw-font-mono tw-outline-none tw-mx-auto"
                 [style.borderColor]="waOtpError ? '#dc2626' : '#e2e8f0'"
                 (keyup.enter)="verifyWaOtp()">
          <p *ngIf="waOtpError" class="tw-text-xs tw-text-red-600 tw-mt-3">{{ waOtpError }}</p>
          <button (click)="verifyWaOtp()" [disabled]="waOtpCode.length < 6 || waVerifyingOtp" type="button"
                  class="tw-w-full tw-mt-4 tw-py-3 tw-rounded-xl tw-text-white tw-font-semibold tw-text-sm tw-border-0 tw-cursor-pointer"
                  [style.background]="waOtpCode.length < 6 || waVerifyingOtp ? '#94a3b8' : '#25D366'">
            <span *ngIf="!waVerifyingOtp">Verificar</span>
            <span *ngIf="waVerifyingOtp">Verificando...</span>
          </button>
          <button (click)="resendWaOtp()" [disabled]="waResendCooldown > 0 || waSendingOtp" type="button"
                  class="tw-mt-4 tw-text-sm tw-font-medium tw-bg-transparent tw-border-0 tw-cursor-pointer"
                  [style.color]="(waResendCooldown > 0 || waSendingOtp) ? '#94a3b8' : '#25D366'">
            {{ waResendCooldown > 0 ? 'Reenviar código en ' + waResendCooldown + 's' : (waSendingOtp ? 'Enviando...' : 'Reenviar código') }}
          </button>
        </div>

        <!-- WhatsApp: confirmar cuenta existente -->
        <div *ngIf="waStep === 'confirm'" class="tw-mb-5 tw-text-center">
          <div class="tw-flex tw-items-center tw-justify-center tw-w-14 tw-h-14 tw-rounded-xl tw-bg-blue-100 tw-mb-4 tw-mx-auto">
            <svg class="tw-w-7 tw-h-7" style="color:#2563eb" fill="none" viewBox="0 0 24 24" stroke="currentColor" stroke-width="2">
              <path stroke-linecap="round" stroke-linejoin="round" d="M5.121 17.804A13.937 13.937 0 0112 16c2.5 0 4.847.655 6.879 1.804M15 10a3 3 0 11-6 0 3 3 0 016 0zm6 2a9 9 0 11-18 0 9 9 0 0118 0z"/>
            </svg>
          </div>
          <p class="tw-text-sm tw-text-slate-700 tw-mb-1">Encontramos una cuenta con este número:</p>
          <p class="tw-text-sm tw-font-semibold tw-text-slate-900 tw-mb-6">{{ waMaskedEmail }}</p>
          <button (click)="resolveWa('LINK')" [disabled]="waResolving" type="button"
                  class="tw-w-full tw-py-3 tw-rounded-xl tw-text-white tw-font-semibold tw-text-sm tw-border-0 tw-cursor-pointer tw-mb-3"
                  style="background:#25D366">
            Sí, es mía — entrar
          </button>
          <button (click)="resolveWa('NEW')" [disabled]="waResolving" type="button"
                  class="tw-w-full tw-py-3 tw-rounded-xl tw-text-sm tw-font-medium tw-bg-transparent tw-border tw-border-slate-200 tw-cursor-pointer"
                  style="color:#475569">
            No, soy una persona distinta
          </button>
        </div>

        <ng-container *ngIf="waStep === 'idle'">
        <!-- Google Button -->
        <div id="google-btn-container" class="tw-w-full tw-flex tw-justify-center tw-mb-3"></div>

        <!-- LinkedIn -->
        <button (click)="loginLinkedIn()" type="button"
                class="tw-w-full tw-h-11 tw-flex tw-items-center tw-justify-center tw-gap-3
                       tw-px-4 tw-rounded-xl tw-border tw-border-slate-200
                       tw-bg-white hover:tw-bg-slate-50 tw-transition tw-duration-150
                       tw-text-sm tw-font-medium tw-text-slate-700 tw-cursor-pointer tw-mb-5">
          <svg class="tw-w-5 tw-h-5 tw-shrink-0" viewBox="0 0 24 24" fill="#0A66C2">
            <path d="M20.447 20.452h-3.554v-5.569c0-1.328-.027-3.037-1.852-3.037-1.853 0-2.136 1.445-2.136 2.939v5.667H9.351V9h3.414v1.561h.046c.477-.9 1.637-1.85 3.37-1.85 3.601 0 4.267 2.37 4.267 5.455v6.286zM5.337 7.433a2.062 2.062 0 01-2.063-2.065 2.064 2.064 0 112.063 2.065zm1.782 13.019H3.555V9h3.564v11.452zM22.225 0H1.771C.792 0 0 .774 0 1.729v20.542C0 23.227.792 24 1.771 24h20.451C23.2 24 24 23.227 24 22.271V1.729C24 .774 23.2 0 22.222 0h.003z"/>
          </svg>
          Continuar con LinkedIn
        </button>

        <!-- Separator -->
        <div class="tw-flex tw-items-center tw-gap-3 tw-mb-5">
          <hr class="tw-flex-1 tw-border-slate-200">
          <span class="tw-text-xs tw-text-slate-400 tw-font-medium">o continúa con correo</span>
          <hr class="tw-flex-1 tw-border-slate-200">
        </div>

        <!-- Email / Password form -->
        <form [formGroup]="formLogin" (ngSubmit)="iniciarSesion()" novalidate class="tw-space-y-4">

          <div>
            <label class="tw-block tw-text-sm tw-font-medium tw-text-slate-700 tw-mb-1.5">Correo electrónico</label>
            <input type="email" formControlName="email" autocomplete="email"
                   placeholder="tu@correo.com"
                   class="tw-w-full tw-px-4 tw-py-2.5 tw-rounded-xl tw-border tw-border-slate-200
                          tw-text-slate-900 tw-text-sm tw-outline-none
                          focus:tw-ring-2 focus:tw-ring-blue-500/30 focus:tw-border-blue-500
                          tw-transition tw-duration-150">
            <div *ngIf="formLogin.controls.email.errors && enviandoLogin" class="tw-mt-1.5 tw-text-xs tw-text-red-500">
              <span *ngIf="formLogin.controls.email.errors.required">El correo es requerido.</span>
              <span *ngIf="formLogin.controls.email.errors.pattern">Formato de correo inválido.</span>
            </div>
          </div>

          <div>
            <div class="tw-flex tw-justify-between tw-items-center tw-mb-1.5">
              <label class="tw-text-sm tw-font-medium tw-text-slate-700">Contraseña</label>
              <a routerLink="/cambiar-password"
                 class="tw-text-xs tw-text-blue-600 hover:tw-text-blue-700 tw-font-medium">
                ¿Olvidaste tu contraseña?
              </a>
            </div>
            <div class="tw-relative">
              <input [type]="showPassword ? 'text' : 'password'" formControlName="password" autocomplete="current-password"
                     placeholder="••••••••"
                     class="tw-w-full tw-px-4 tw-py-2.5 tw-pr-10 tw-rounded-xl tw-border tw-border-slate-200
                            tw-text-slate-900 tw-text-sm tw-outline-none
                            focus:tw-ring-2 focus:tw-ring-blue-500/30 focus:tw-border-blue-500
                            tw-transition tw-duration-150">
              <button type="button" (click)="showPassword = !showPassword"
                      class="tw-absolute tw-right-3 tw-top-1/2 -tw-translate-y-1/2 tw-text-slate-400 hover:tw-text-slate-600 tw-bg-transparent tw-border-0 tw-p-0 tw-cursor-pointer">
                <svg *ngIf="!showPassword" class="tw-w-4 tw-h-4" fill="none" viewBox="0 0 24 24" stroke="currentColor" stroke-width="2">
                  <path stroke-linecap="round" stroke-linejoin="round" d="M2.036 12.322a1.012 1.012 0 010-.639C3.423 7.51 7.36 4.5 12 4.5c4.638 0 8.573 3.007 9.963 7.178.07.207.07.431 0 .639C20.577 16.49 16.64 19.5 12 19.5c-4.638 0-8.573-3.007-9.964-7.178z"/>
                  <path stroke-linecap="round" stroke-linejoin="round" d="M15 12a3 3 0 11-6 0 3 3 0 016 0z"/>
                </svg>
                <svg *ngIf="showPassword" class="tw-w-4 tw-h-4" fill="none" viewBox="0 0 24 24" stroke="currentColor" stroke-width="2">
                  <path stroke-linecap="round" stroke-linejoin="round" d="M3.98 8.223A10.477 10.477 0 001.934 12C3.226 16.338 7.244 19.5 12 19.5c.993 0 1.953-.138 2.863-.395M6.228 6.228A10.45 10.45 0 0112 4.5c4.756 0 8.773 3.162 10.065 7.498a10.523 10.523 0 01-4.293 5.774M6.228 6.228L3 3m3.228 3.228l3.65 3.65m7.894 7.894L21 21m-3.228-3.228l-3.65-3.65m0 0a3 3 0 10-4.243-4.243m4.242 4.242L9.88 9.88"/>
                </svg>
              </button>
            </div>
            <div *ngIf="formLogin.controls.password.errors && enviandoLogin" class="tw-mt-1.5 tw-text-xs tw-text-red-500">
              <span *ngIf="formLogin.controls.password.errors.required">La contraseña es requerida.</span>
            </div>
          </div>

          <!-- Error general -->
          <div *ngIf="mensajeError && !hayError"
               class="tw-flex tw-items-start tw-gap-2 tw-px-4 tw-py-3 tw-rounded-xl tw-bg-red-50 tw-border tw-border-red-200">
            <svg class="tw-w-4 tw-h-4 tw-text-red-500 tw-mt-0.5 tw-shrink-0" viewBox="0 0 20 20" fill="currentColor">
              <path fill-rule="evenodd" d="M10 18a8 8 0 100-16 8 8 0 000 16zM8.28 7.22a.75.75 0 00-1.06 1.06L8.94 10l-1.72 1.72a.75.75 0 101.06 1.06L10 11.06l1.72 1.72a.75.75 0 101.06-1.06L11.06 10l1.72-1.72a.75.75 0 00-1.06-1.06L10 8.94 8.28 7.22z" clip-rule="evenodd"/>
            </svg>
            <div>
              <p class="tw-text-sm tw-text-red-600">{{ mensajeError }}</p>
              <a *ngIf="mensajeError.includes('no te registras')" routerLink="/registrarse"
                 class="tw-inline-block tw-mt-1.5 tw-text-xs tw-font-semibold tw-text-blue-600 hover:tw-underline">
                Crear cuenta →
              </a>
            </div>
          </div>

          <div *ngIf="cuentaNoVerificada"
               class="tw-px-4 tw-py-3 tw-rounded-xl tw-bg-amber-50 tw-border tw-border-amber-200">
            <p class="tw-text-sm tw-font-semibold tw-text-amber-800 tw-mb-2">Tu cuenta aún no está verificada.</p>
            <a [routerLink]="['/verificar']" [queryParams]="{correo: correoNoVerificado}"
               class="tw-inline-flex tw-items-center tw-gap-1.5 tw-px-3 tw-py-1.5 tw-rounded-lg tw-bg-amber-600 tw-text-white tw-text-xs tw-font-semibold tw-no-underline">
              Reenviar código →
            </a>
          </div>

          <button type="submit" [disabled]="enviandoLogin"
                  class="tw-w-full tw-py-2.5 tw-rounded-xl tw-font-semibold tw-text-sm tw-text-white
                         tw-transition tw-duration-150 tw-border-0
                         disabled:tw-opacity-60 disabled:tw-cursor-not-allowed"
                  style="background:linear-gradient(135deg,#1e3a5f,#1d4ed8)">
            <span *ngIf="!enviandoLogin">Iniciar sesión</span>
            <span *ngIf="enviandoLogin" class="tw-flex tw-items-center tw-justify-center tw-gap-2">
              <svg class="tw-w-4 tw-h-4 tw-animate-spin" fill="none" viewBox="0 0 24 24">
                <circle class="tw-opacity-25" cx="12" cy="12" r="10" stroke="currentColor" stroke-width="4"/>
                <path class="tw-opacity-75" fill="currentColor" d="M4 12a8 8 0 018-8v8z"/>
              </svg>
              Verificando…
            </span>
          </button>
        </form>

        <!-- Footer links -->
        <p class="tw-text-center tw-mt-5 tw-text-sm tw-text-slate-600">
          ¿No tienes cuenta?
          <a [routerLink]="['/registrarse']" [queryParams]="{rol: rolSeleccionado}"
             class="tw-font-semibold tw-text-blue-600 hover:tw-underline">Regístrate aquí</a>
        </p>
        <p class="tw-text-center tw-mt-2 tw-text-xs tw-text-slate-400">
          ¿Pendiente de verificar?
          <a routerLink="/verificar" class="tw-font-medium tw-text-blue-600 hover:tw-underline">Ingresa tu código</a>
        </p>
        </ng-container>
      </div>
    </div>
  </div>

  <!-- ── RIGHT PANEL: Feature annotations ──────────────────────────────────── -->
  <div class="tw-hidden xl:tw-flex tw-flex-col tw-justify-start tw-w-64 tw-shrink-0 tw-px-8 tw-pt-10 tw-pb-8 tw-space-y-7 tw-sticky tw-top-0" style="height:calc(100vh - 64px);overflow:hidden">

    <div class="tw-flex tw-items-start tw-gap-3">
      <div class="tw-w-7 tw-h-7 tw-rounded-full tw-bg-blue-600 tw-flex tw-items-center tw-justify-center tw-shrink-0 tw-mt-0.5">
        <svg class="tw-w-3.5 tw-h-3.5 tw-text-white" fill="none" viewBox="0 0 24 24" stroke="currentColor" stroke-width="2.5">
          <path stroke-linecap="round" stroke-linejoin="round" d="M4.5 12.75l6 6 9-13.5"/>
        </svg>
      </div>
      <div>
        <p class="tw-font-bold tw-text-blue-800 tw-text-sm tw-leading-snug">Acceso inmediato</p>
        <p class="tw-text-xs tw-text-slate-500 tw-mt-1 tw-leading-relaxed">El sistema detecta tu tipo de cuenta automáticamente al iniciar sesión.</p>
      </div>
    </div>

    <div class="tw-flex tw-items-start tw-gap-3">
      <div class="tw-w-7 tw-h-7 tw-rounded-full tw-bg-blue-600 tw-flex tw-items-center tw-justify-center tw-shrink-0 tw-mt-0.5">
        <svg class="tw-w-3.5 tw-h-3.5 tw-text-white" fill="none" viewBox="0 0 24 24" stroke="currentColor" stroke-width="2.5">
          <path stroke-linecap="round" stroke-linejoin="round" d="M4.5 12.75l6 6 9-13.5"/>
        </svg>
      </div>
      <div>
        <p class="tw-font-bold tw-text-blue-800 tw-text-sm tw-leading-snug">Google y LinkedIn disponibles</p>
        <p class="tw-text-xs tw-text-slate-500 tw-mt-1 tw-leading-relaxed">Usa el mismo método con el que te registraste para entrar rápido.</p>
      </div>
    </div>

    <div class="tw-flex tw-items-start tw-gap-3">
      <div class="tw-w-7 tw-h-7 tw-rounded-full tw-bg-blue-600 tw-flex tw-items-center tw-justify-center tw-shrink-0 tw-mt-0.5">
        <svg class="tw-w-3.5 tw-h-3.5 tw-text-white" fill="none" viewBox="0 0 24 24" stroke="currentColor" stroke-width="2.5">
          <path stroke-linecap="round" stroke-linejoin="round" d="M4.5 12.75l6 6 9-13.5"/>
        </svg>
      </div>
      <div>
        <p class="tw-font-bold tw-text-blue-800 tw-text-sm tw-leading-snug">¿Primera vez? Regístrate</p>
        <p class="tw-text-xs tw-text-slate-500 tw-mt-1 tw-leading-relaxed">Si no tienes cuenta, ve a Registrarse y elige tu perfil ahí.</p>
      </div>
    </div>

  </div>

</div>
